<template>
  <div>
    <!-- 如果包含children就显示 -->
    <component
      :is="subMenu.children && subMenu.children.length ? 'el-submenu' : 'el-menu-item'"
      v-for="subMenu in menusList"
      :key="subMenu.menuId"
      :index="subMenu.url || subMenu.menuId"
    >
      <template slot="title" v-if="subMenu.children && subMenu.children.length">
        <i
          v-if="filterIcons(subMenu).type === 'icon'"
          :class="filterIcons(subMenu).url"
        ></i>
        <svg
          v-if="filterIcons(subMenu).type === 'image'"
          t="1649303766151"
          class="icon"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="2329"
          :width="isLapTop ? '12' : '24'"
          :height="isLapTop ? '12' : '18'"
          v-html="filterIcons(subMenu).svg"
        ></svg>
        <!-- <img
          v-if="filterIcons(subMenu).type === 'image'"
          :src="filterIcons(subMenu).url"
        /> -->
        <span :title="subMenu.name">{{ subMenu.name }}</span>
      </template>
      <i v-if="!subMenu.children" :class="filterIcons(subMenu).url"></i>
      <span v-if="!subMenu.children" :title="subMenu.name">{{ subMenu.name }}</span>
      <sub-menu-item :menu-data="subMenu.children"></sub-menu-item>
    </component>
  </div>
</template>
<script>
import icons from "@/static/asideIcons.js";
export default {
  data() {
    return {
      menusList: [],
    };
  },
  name: "subMenuItem",
  props: {
    menuData: {
      default: () => [],
      type: Array,
    },
  },
  watch: {
    menuData: {
      handler(val) {
        this.menusList = this.$lodash.sortBy(val, (value) => {
          return value.orderNum;
        });
      },
      immediate: true,
    },
  },
  methods: {
    filterIcons(item) {
      if (icons[item.code]) {
        return icons[item.code];
      } else {
        return false;
      }
    },
  },
  created() {},
};
</script>
<style lang="less" scoped>
::v-deep .el-submenu__title {
  svg {
    width: 24px;
    padding-left: 2px;
    margin-right: 5px;
  }
}
::v-deep .el-submenu__title {
  span {
    display: inline-block;
    max-width: 180px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
::v-deep .el-menu-item {
  span {
    display: inline-block;
    max-width: 160px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
